import { render, staticRenderFns } from "./GoToDesktop.vue?vue&type=template&id=7531680c&scoped=true&"
import script from "./GoToDesktop.vue?vue&type=script&lang=ts&"
export * from "./GoToDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./GoToDesktop.vue?vue&type=style&index=0&id=7531680c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7531680c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
